import { render } from "./gdfx.vue?vue&type=template&id=4484689c&scoped=true&ts=true"
import script from "./gdfx.vue?vue&type=script&lang=ts"
export * from "./gdfx.vue?vue&type=script&lang=ts"

import "./gdfx.vue?vue&type=style&index=0&id=4484689c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4484689c"]])

export default __exports__